import { BASE_V2_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'CURRICULUM_TAGS_GET_ALL',
  GET_ALL_SUCCESS: 'CURRICULUM_TAGS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'CURRICULUM_TAGS_GET_ALL_FAILURE',
  POST: 'CURRICULUM_TAGS_POST',
  POST_SUCCESS: 'CURRICULUM_TAGS_POST_SUCCESS',
  POST_FAILURE: 'CURRICULUM_TAGS_POST_FAILURE',
  PATCH: 'CURRICULUM_TAGS_PATCH',
  PATCH_SUCCESS: 'CURRICULUM_TAGS_PATCH_SUCCESS',
  PATCH_FAILURE: 'CURRICULUM_TAGS_PATCH_FAILURE',
};

export const getAll = actions.getAll(query => `${BASE_V2_URL}/practice-sheet-tags/`, {
  PENDING: ACTIONS.GET_ALL,
  SUCCESS: ACTIONS.GET_ALL_SUCCESS,
  FAILURE: ACTIONS.GET_ALL_FAILURE,
});

export const post = actions.post(() => `${BASE_V2_URL}/tags/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const patch = actions.patch(tagId => `${BASE_V2_URL}/tags/${tagId}/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
